import { useHistoryCustomBack } from 'weblite-router'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Components
import { BottomDrawer } from '$common/bottom-drawer'
import { CulturalContentsSelectMenu } from '$comp/navigation-bar-tool-box/components/cultural-contents-select-menu'
import { showToolboxModal } from '$comp/modals/toolbox/index'

export function ToolboxCulturalContentsModal({ isOpen }: { isOpen: boolean }) {
  const onBack = async () => {
    await closeCurrentModal()
    showToolboxModal()
  }

  useHistoryCustomBack(onBack, [])

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={closeCurrentModal}
      bottomSafeAreaColor="veryLightGray"
    >
      <CulturalContentsSelectMenu onBack={onBack} />
    </BottomDrawer>
  )
}
